import React from 'react';

import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import {
  QueryClientProvider
} from '@tanstack/react-query';
import * as Sentry from '@sentry/react';

import Base from 'react/containers/layout/Base';
import Login from 'react/containers/pages/Login';
import RecoverCredentials from 'react/containers/pages/RecoverCredentials';
import RecoverPassword from 'react/containers/pages/ResetPassword';

import history from 'react/api/history';
import { store } from 'react/api/store';
import queryClient from 'react/services/queryClient';

const SentryRoute = Sentry.withSentryRouting(Route);

Sentry.init({
  dsn: 'https://718b8b853e11bd714cbab8fca8a28f54@o4507805653270528.ingest.us.sentry.io/4510312916189184',
  integrations: [
    Sentry.reactRouterV5BrowserTracingIntegration({ history })
  ],
  tracesSampleRate: 0.1,
  sendDefaultPii: true,
  release: App.Version.GMLVersionName || 'unknown'
});

Sentry.setTag("gmlive.build.number", App.Version.GMLBuildNumber || 'unknown');
Sentry.setTag("gms.versionName", App.Version.GMSVersionName || 'unknown');

export default function GreenmileApplication() {
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <ConnectedRouter history={history}>
          <Switch>
            <SentryRoute path="/login" component={Login} />
            <SentryRoute path="/RecoverPassword" component={RecoverPassword} />
            <SentryRoute path="/RecoverCredentials" component={RecoverCredentials} />
            <SentryRoute component={Base} />
          </Switch>
        </ConnectedRouter>
      </QueryClientProvider>
    </Provider>
  );
}
